import { render, staticRenderFns } from "./CustomFieldValueInput.vue?vue&type=template&id=65af6c68&"
import script from "./CustomFieldValueInput.vue?vue&type=script&lang=js&"
export * from "./CustomFieldValueInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports